<template>
  <div class="container">
    <loading :active="loading" :is-full-page="true" loader="bars"></loading>
    <div class="row">
      <div class="card mt-5">
        <div class="card-body">
          <h3 class="text-center">Job Posts</h3>
          <div class="col-md-12 d-flex justify-content-end">
            <router-link
              v-if="permissions.includes('job_post_add')"
              to="/jobPosts/add"
              class="btn btn-sm btn-primary mb-2"
              >Add Post</router-link
            >
          </div>
          <div class="col-md-12">
            <data-table
              :columns="columns"
              :module="module"
              :items="items"
              :isEdit="isEdit"
              :isDelete="isDelete"
              @deleted="fetch"
              @nextPage="nextPage"
              @search="fetch"
              @clear="fetch"
            ></data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from "@/components/dataTable.vue";
import axiosInstance from "@/helpers/axios";

export default {
  components: {
    DataTable,
  },
  data() {
    return {
      items: [],
      columns: [
        {
          text: "Title",
          value: "title",
        },
        {
          text: "Category",
          value: "category",
          secondValue: "name",
        },
        {
          text: "Employer",
          value: "employer",
          secondValue: "full_name",
        },
        {
          text: "Job Type",
          value: "type",
        },
        {
          text: "Status",
          value: "status",
        },
      ],
      module: "jobPosts",
      loading: false,
      permissions: [],
      isEdit: false,
      isDelete: false,
    };
  },
  created() {
    this.permissions = localStorage.getItem("permissions");
    if (this.permissions.includes("job_post_edit")) {
      this.isEdit = true;
    }
    if (this.permissions.includes("job_post_delete")) {
      this.isDelete = true;
    }
    this.fetch();
  },
  methods: {
    nextPage(url) {
      this.loading = true;
      axiosInstance.get(url).then((response) => {
        this.items = response.data.data;
        this.loading = false;
      });
    },
    fetch(search = "") {
      this.loading = true;
      this.$store
        .dispatch("jobPosts/getAll", { search })
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e.error);
        });
    },
  },
};
</script>
